<template lang="html">
    <div class="container-fluid p-2 p-lg-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="back-btn" type="button" @click="back()" v-if="filter.redirect == 'daily' || filter.redirect == 'agent'">
                            <i class="fas fa-arrow-left"></i>
                        </button>
                        Member Report List
                    </div>
                    <div class="card-body">
                         <div class="row" v-if="filter.redirect != 'daily' && filter.redirect != 'agent'">
                            <div class="col-md-12">
                                <div class="row search-form">
                                    <div class="col-md-3 mt-1">
                                        <input
                                            v-model="filter.agent_name"
                                            class="form-control"
                                            placeholder="Agent Name"
                                        >
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <b-form-datepicker
                                            v-model="filter.from"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                     <div class="col-md-3 mt-1">
                                        <b-form-datepicker
                                            v-model="filter.to"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                        <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table" :style="{ '--accordion-row-bg': accordionBg }">
                                <colgroup>
                                    <col style="width: 24%" />
                                    <col style="width: 16%" />
                                    <col style="width: 10%" />
                                    <col style="width: 10%" />
                                    <col style="width: 10%" />
                                    <col style="width: 10%" />
                                    <col style="width: 10%" />
                                    <col style="width: 10%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th rowspan="2" class="text-left align-middle">Member Name</th>
                                        <th rowspan="2" class="text-center align-middle">Agent Name</th>
                                        <th colspan="3" class="text-center">Master</th>
                                        <th colspan="3" class="text-center">Agent</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center">Bet</th>
                                        <th class="text-center">Commission</th>
                                        <th class="text-center">W/L</th>
                                        <th class="text-center">Bet</th>
                                        <th class="text-center">Commission</th>
                                        <th class="text-center">W/L</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(data, index) in dataList">
                                        <tr :key="data.id">
                                            <td class="text-left">
                                                <button
                                                    class="accordion-icon-btn mr-2"
                                                    @click.prevent="toggleAccordion(index)"
                                                    :aria-expanded="isAccordionOpen(index)"
                                                    :aria-label="isAccordionOpen(index) ? 'Hide details' : 'Show details'"
                                                >
                                                    <i :class="isAccordionOpen(index) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                                                </button>
                                                <span>{{ data.member_name }}</span>
                                            </td>
                                            <td class="text-center">{{ data.agent_name }}</td>
                                            <td class="text-center">{{ data.total_bet_amount }}</td>
                                            <td class="text-center">{{ data.total_master_commission }}</td>
                                            <td class="text-center">{{ data.total_master_win_or_lose }}</td>
                                            <td class="text-center">{{ data.total_bet_amount }}</td>
                                            <td class="text-center">{{ data.total_agent_commission}}</td>
                                            <td class="text-center">{{ data.total_agent_commission }}</td>
                                        </tr>
                                            <template v-if="isAccordionOpen(index)">
                                                <tr v-if="memberDetailsLoading && memberDetailsLoading[data.id]" :key="'acc-loading-' + data.id" class="accordion-row">
                                                    <td colspan="8" class="text-center">Loading...</td>
                                                </tr>
                                                <tr v-else-if="memberDetailsCache && memberDetailsCache[data.id] && memberDetailsCache[data.id].error" :key="'acc-error-' + data.id" class="accordion-row">
                                                    <td colspan="8" class="text-center text-danger">{{ memberDetailsCache[data.id].error }}</td>
                                                </tr>
                                                <template v-else>
                                                    <tr v-for="(item, i) in normalizeWinLose(memberDetailsCache && memberDetailsCache[data.id])" :key="'acc-' + data.id + '-' + i" class="accordion-row">
                                                        <td class="text-left" >
                                                            <button v-if="item.type == 'accumulator'" @click="showDetail(item.accumulator_order_items)" class="accordion-icon-btn mr-2" >
                                                                <i class="fa fa-eye"></i>
                                                            </button>
                                                            <button v-if="item.type == 'handicap'" @click="showDetail(item.handicap_order_item)" class="accordion-icon-btn mr-2" >
                                                                <i class="fa fa-eye"></i>
                                                            </button>
                                                            <span>{{ item.order_number || '-' }}</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="badge" :class="statusClass(item.status)">{{ item.status || '-' }}</span>
                                                        </td>
                                                        <td class="text-center">{{ item.predicted_coin }}</td>
                                                        <td class="text-center">{{ item.master_commission_amount }}</td>
                                                        <td class="text-center">{{ item.master_amount }}</td>
                                                        <td class="text-center">{{ item.predicted_coin }}</td>
                                                        <td class="text-center">{{ item.agent_commission_amount }}</td>
                                                        <td class="text-center">{{ item.agent_commission_amount }}</td>
                                                    </tr>
                                                    <tr v-if="normalizeWinLose(memberDetailsCache && memberDetailsCache[data.id]).length === 0" :key="'acc-empty-' + data.id" class="accordion-row">
                                                        <td colspan="8" class="text-center">No records</td>
                                                    </tr>
                                                </template>
                                            </template>
                                    </template>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="8" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="table-pagination-minimal">
                                <div class="table-pagination-row">
                                    <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                        Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                    </div>
                                    <nav class="pagination-minimal">
                                        <ul>
                                            <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                                <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                    <i class="fas fa-angle-left"></i>
                                                </button>
                                            </li>
                                            <li v-for="page in metaData.last_page" :key="page"
                                                :class="{ 'active':metaData.current_page === page }"
                                                v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                                <button @click.prevent="next(page)">{{ page }}</button>
                                            </li>
                                            <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                                <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                    <i class="fas fa-angle-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <b-modal id="bv-modal-detail" ref="my-modal" title="Prediction Details" hide-footer size="xl">
                            <template>
                                <div class="table-responsive mt-4">
                                    <div class="table-card">
                                        <table class="common-table modal-table">
                                            <colgroup>
                                                <col style="width: 30%" />
                                                <col style="width: 12%" />
                                                <col style="width: 30%" />
                                                <col style="width: 13%" />
                                                <col style="width: 15%" />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th class="text-left align-middle">Home</th>
                                                    <th class="text-center align-middle">Goal Score</th>
                                                    <th class="text-left align-middle">Away</th>
                                                    <th class="text-left align-middle">Goal Price</th>
                                                    <th class="text-center align-middle">Bet Choice</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in predictionData" class="accordion-row">
                                                    <td class="text-left">
                                                        {{ (item.fixture && item.fixture.home_team && item.fixture.home_team.name) || '-' }}
                                                        <span v-if="item.prediction_type == 'body' && item.is_home_team_upper === true">
                                                            <span v-if="item.handicap_value == 0">= </span>
                                                            <span v-else>{{ item.handicap_value }}</span>
                                                            {{ formatSigned(item.handicap_price) }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">{{item.fixture.home_team_score}} - {{ item.fixture.away_team_score }}</td>
                                                    <td class="text-left">
                                                        {{ (item.fixture && item.fixture.away_team && item.fixture.away_team.name) || '-' }}
                                                        <span v-if="item.prediction_type == 'body' && item.is_home_team_upper === false">
                                                            <span v-if="item.handicap_value == 0">= </span>
                                                            <span v-else>{{ item.handicap_value }}</span>
                                                            {{ formatSigned(item.handicap_price) }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span v-if="item.prediction_type == 'goal_total'">
                                                            {{ item.handicap_value }} {{ formatSigned(item.handicap_price) }}
                                                        </span>
                                                        <span v-else>-</span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span v-if="item.predicted_side == 'home'">
                                                            {{item.fixture.home_team.name}}
                                                        </span>
                                                        <span v-if="item.predicted_side == 'away'">
                                                            {{item.fixture.away_team.name}}
                                                        </span>
                                                        <span v-if="item.predicted_side == 'over'">
                                                            OVER (ဂိုလ်းပေါ်)
                                                        </span>
                                                        <span v-if="item.predicted_side == 'under'">
                                                            UNDER (ဂိုလ်းအောက်)
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr v-if="!predictionData || predictionData.length === 0">
                                                    <td colspan="5" class="text-center">No prediction details</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </template>
                        </b-modal>
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import { BFormDatepicker } from 'bootstrap-vue'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'memberReportList',
        metaInfo: {
            title: "Member Report List",
            titleTemplate: "%s ← BXB",
        },
        components: {
            Loading,
            BFormDatepicker
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                id: '',
                userName: '',
                status: '',
                dataList: [],
                predictionData: [],
                permissions: '',
                columns: {
                    "member_name": "Member Name",
                    "agent_name": "Agent Name",
                    "total_deposit": "Total Deposit",
                    "total_withdraw": "Total Withdraw",
                    "net_deposit": "Net Deposit"
                },
                filter: {
                    page: 1,
                    orderBy: "asc",
                    sortKey: "created_at",
                    limit: 10,
                    agent_name: '',
                    from: new Date().toISOString().slice(0, 10),
                    to: new Date().toISOString().slice(0, 10),
                    redirect: "",
                    agPage: "",
                    agOrderBy: "",
                    agSortKey: "",
                    agLimit: "",
                    agFrom: "",
                    agTo: "",
                    rePage: "",
                    reOrderBy: "",
                    reSortKey: "",
                    reLimit: "",
                    reFrom: "",
                    reTo: ""
                },
                
                openAccordionIndex: null,
                memberDetailsCache: {},
                memberDetailsLoading: {},
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                },
                // Change this to set accordion rows background color
                accordionBg: '#accecf'
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            async toggleAccordion(index) {
                if (this.openAccordionIndex === index) {
                    this.openAccordionIndex = null;
                    return;
                }
                this.openAccordionIndex = index;
                const row = this.dataList[index];
                if (!row) return;
                const key = row.id;
                // Always fetch fresh data when opening
                if (this.memberDetailsCache[key]) {
                    this.$delete(this.memberDetailsCache, key);
                }
                this.$set(this.memberDetailsLoading, key, true);
                try {
                    const userId = row.user_id || row.member_id || row.id;
                    const res = await this.memberWinLoseReportListAction({
                        user_id: userId,
                        from: this.filter.from,
                        to: this.filter.to
                    });
                    if (res && res.success) {
                        this.$set(this.memberDetailsCache, key, res.data);
                    } else {
                        const message = (res && res.message) ? res.message : 'Failed to load details';
                        this.$set(this.memberDetailsCache, key, { error: message });
                    }
                } catch (e) {
                    const message = (e && e.message) ? e.message : 'Failed to load details';
                    this.$set(this.memberDetailsCache, key, { error: message });
                } finally {
                    this.$delete(this.memberDetailsLoading, key);
                }
            },
            isAccordionOpen(index) {
                return this.openAccordionIndex === index;
            },
            normalizeWinLose(payload) {
                // Accept array or object with data property
                if (!payload) return [];
                if (Array.isArray(payload)) return payload;
                if (payload.data && Array.isArray(payload.data)) return payload.data;
                if (payload.items && Array.isArray(payload.items)) return payload.items;
                return [];
            },
            statusClass(status) {
                const s = (status || '').toString().toLowerCase();
                return {
                    'badge-success': s === 'win' || s === 'completed' || s === 'success',
                    'badge-danger': s === 'lose' || s === 'failed' || s === 'lost',
                    'badge-warning': s === 'pending' || s === 'processing'
                };
            },
            
            ...mapActions({
                memberReportListAction: 'memberReportListAction',
                memberWinLoseReportListAction: 'memberWinLoseReportListAction'
            }),
            sortBy(column) {
                this.filter.sortKey = column
                if (this.filter.sortKey == column) {
                    if (this.filter.orderBy == "asc") {
                        this.filter.orderBy = "desc"
                    } else if (this.filter.orderBy == "desc") {
                        this.filter.orderBy = "asc"
                    }
                } else {
                    this.filter.orderBy = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                let option = this.filter
                await this.memberReportListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.lastPage
                        this.metaData.current_page = res.data.meta.currentPage
                        this.metaData.prev_page_url = res.data.meta.prevPageUrl
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        console.log("Filter", this.filter)
                        this.$router.replace({ 
                            path: 'member-report-list', 
                            query: { 
                                page: this.filter.page, 
                                orderBy: this.filter.orderBy, 
                                sortKey: this.filter.sortKey,
                                agent_name: this.filter.agent_name,
                                from: this.filter.from,
                                to: this.filter.to,
                                redirect: this.filter.redirect,
                                agPage: this.filter.agPage,
                                agOrderBy: this.filter.agOrderBy,
                                agSortKey: this.filter.agSortKey,
                                agLimit: this.filter.agLimit,
                                agFrom: this.filter.agFrom,
                                agTo: this.filter.agTo,
                                rePage: this.filter.rePage,
                                reOrderBy: this.filter.reOrderBy,
                                reSortKey: this.filter.reSortKey,
                                reLimit: this.filter.reLimit,
                                reFrom: this.filter.reFrom,
                                reTo: this.filter.reTo
                            } 
                        }).catch(()=>{})
                        this.isLoading = false;
                    }
                    console.log(res)
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'member-report-list', 
                    query: {
                        page: 1, 
                        orderBy: 'desc', 
                        sortKey: 'created_at'
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.id = data.id
                this.userName = data.user_name
                this.status = data.status
            },
            back(){
                this.$router.replace({
                    path: 'agent-report-list',
                    query: {
                        page: this.filter.agPage,
                        orderBy: this.filter.agOrderBy,
                        sortKey: this.filter.agSortKey,
                        limit: this.filter.agLimit,
                        from: this.filter.agFrom,
                        to: this.filter.agTo,
                        redirect: this.filter.redirect,
                        rePage: this.filter.rePage,
                        reOrderBy: this.filter.reOrderBy,
                        reSortKey: this.filter.reSortKey,
                        reLimit: this.filter.reLimit,
                        reFrom: this.filter.reFrom,
                        reTo: this.filter.reTo
                    }
                }).catch(()=>{})
            },
            showDetail(orderItems) {
                // Normalize to an array and deep-clone to avoid shared references
                const normalized = Array.isArray(orderItems)
                    ? orderItems
                    : (orderItems ? [orderItems] : []);
                const cloned = JSON.parse(JSON.stringify(normalized));

                // Clear first to ensure re-render, then set and open modal after DOM updates
                this.predictionData = [];
                this.$nextTick(() => {
                    this.predictionData = cloned;
                    this.$nextTick(() => {
                        if (this.$bvModal) {
                            this.$bvModal.show('bv-modal-detail');
                        } else if (this.$refs['my-modal']) {
                            // Fallback in case $bvModal is unavailable
                            this.$refs['my-modal'].show();
                        }
                    });
                });
            },
            formatGoalScore(item) {
                const ft = (item && item.fixture) || {};
                const hs = (ft.home_score != null) ? ft.home_score : (ft.score && ft.score.home);
                const as = (ft.away_score != null) ? ft.away_score : (ft.score && ft.score.away);
                if (hs == null || as == null) return '-';
                return `${hs} - ${as}`;
            },
            formatBetChoice(item) {
                if (!item) return '-';
                // common fields: market, pick, odd
                const market = item.market || (item.bet && item.bet.market);
                const pick = item.pick || (item.bet && item.bet.pick);
                const odd = (item.odd != null) ? item.odd : (item.bet && item.bet.odd);
                const parts = [];
                if (market) parts.push(market);
                if (pick) parts.push(pick);
                if (odd != null) parts.push(`@ ${odd}`);
                return parts.length ? parts.join(' ') : '-';
            },
            formatSigned(value) {
                if (value === null || value === undefined || value === '') return '-';
                // Accept string or number; trim whitespace
                const str = String(value).trim();
                if (str.startsWith('-')) return str; // already negative
                if (str.startsWith('+')) return str; // already positive with sign
                // Parse to number to avoid double signs on things like ' 0 '
                const num = Number(str);
                if (Number.isNaN(num)) return str; // not a number, return as-is
                return num >= 0 ? `+${num}` : String(num);
            },
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            }

        },
        async mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.filter.page = this.$route.query.page
            this.filter.orderBy = this.$route.query.orderBy
            this.filter.sortKey = this.$route.query.sortKey
            this.filter.agent_name = this.$route.query.agent_name || ""
            if(this.$route.query.from){
                this.filter.from = this.$route.query.from
            }
            if(this.$route.query.to){
                this.filter.to = this.$route.query.to
            }
            this.filter.redirect = this.$route.query.redirect || ""
            this.filter.agPage = this.$route.query.agPage
            this.filter.agOrderBy = this.$route.query.agOrderBy
            this.filter.agSortKey = this.$route.query.agSortKey
            this.filter.agLimit = this.$route.query.agLimit
            this.filter.agFrom = this.$route.query.agFrom
            this.filter.agTo = this.$route.query.agTo
            this.filter.rePage = this.$route.query.rePage
            this.filter.reOrderBy = this.$route.query.reOrderBy
            this.filter.reSortKey = this.$route.query.reSortKey
            this.filter.reLimit = this.$route.query.reLimit
            this.filter.reFrom = this.$route.query.reFrom
            this.filter.reTo = this.$route.query.reTo

            await this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }

/* Ensure consistent alignment between main and accordion rows */
.common-table {
    width: 100%;
    table-layout: fixed; /* respect colgroup widths */
    border-collapse: separate;
    border-spacing: 0;
}
// .common-table thead th {
//     background: #f5f7fb;
//     color: #1f2d3d;
//     font-weight: 600;
//     border-bottom: 1px solid #e9ecef;
//     padding: 10px 12px;
// }
.common-table tbody td {
    padding: 10px 12px;
    border-bottom: 1px solid #e9ecef;
    vertical-align: middle;
}
.common-table .accordion-row td {
    background: var(--accordion-row-bg, #f9fbff);
}
.common-table .accordion-row:last-of-type td {
    border-bottom: 1px solid #e9ecef;
}

.table-card {
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(44,62,80,0.06);
}
.modal-table thead th {
     background: #4F8A8B;
}
.modal-table tbody tr:nth-child(odd) td {
    background: #fbfdff;
}
.modal-table tbody tr:hover td {
    background: #f3f8ff;
}

.accordion-details-card {
    background: #fff;
    border: 1px solid #e3e6f0;
    border-radius: 6px;
    margin: 12px 0;
    padding: 18px 24px 12px 24px;
    box-shadow: 0 2px 8px 0 rgba(44,62,80,0.04);
    font-size: 15px;
}
.accordion-icon-btn {
    background: #fff;
    border: 1.5px solid #4e73df;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, color 0.2s;
    outline: none;
    font-size: 16px;
    color: #4e73df;
    margin-right: 8px;
}
.accordion-icon-btn:hover, .accordion-icon-btn:focus {
    background: #4e73df;
    color: #fff;
    border-color: #1cc88a;
}

/* Beautify BootstrapVue datepicker in this view */
::v-deep .b-form-datepicker {
    font-family: inherit;
}
::v-deep .b-form-datepicker .form-control,
::v-deep .b-form-datepicker .b-form-datepicker .btn {
    height: 38px;
    border-radius: 6px;
}
::v-deep .b-calendar .b-calendar-grid-body .btn {
    border-radius: 6px;
}
::v-deep .b-calendar .b-calendar-header .btn {
    background: #f7f9fc;
    border: 1px solid #e6ebf1;
}
::v-deep .b-calendar .b-calendar-grid .col[data-date] .btn {
    transition: all .15s ease-in-out;
}
::v-deep .b-calendar .b-calendar-grid .col[data-date] .btn:hover {
    background: #edf3ff;
    color: #1b4b91;
}
::v-deep .b-calendar .b-calendar-grid .col[data-date] .btn.active,
::v-deep .b-calendar .b-calendar-grid .col[data-date] .btn.bg-primary {
    background: #4e73df !important;
    border-color: #4e73df !important;
}
::v-deep .b-calendar .b-calendar-grid .col[data-date] .btn.text-muted {
    color: #b5bcc9 !important;
}
::v-deep .b-calendar .b-calendar-footer .btn {
    border-radius: 20px;
    padding: 6px 14px;
}
</style>